export const handleShowPenaltyScore = (teamOne, teamTwo) => {
    let showPenaltyScore = false;
    if (isNaN(teamOne?.score && teamTwo?.score)) return showPenaltyScore;
    if (teamOne.score !== teamTwo.score) return showPenaltyScore;
    if ((teamOne.penalty_score + teamTwo.penalty_score) > 0 || (teamOne.penalties_score + teamTwo.penalties_score) > 0) showPenaltyScore = true;
    return showPenaltyScore;
}